import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
  serviceRequestQuotations: [],
  quotationList : [],
  quotationMeta : {},
  serviceRequestQuotation: {
    total: null
  },
  detailedProductData: [
    {
      productId: "",
      name: "",
      quantity: null,
      taxRate: null,
    },
  ],
  detailedLaborCosts: []
}
const serviceRequestQuotation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default serviceRequestQuotation;